module.exports = __webpack_public_path__ + "img/2_3.5be4c527.png";